import tpl from './tab-bar.tpl.html';

class MDCTabBarComponent {
  constructor($element, $timeout, $scope) {
    'ngInject';

    this.$element = $element;
    this.$timeout = $timeout;
    this.$scope = $scope;

    this._tabBar = null;

    /**
     * Tab item
     * @typedef {Object} TabItem
     * @property {?String} icon - Icon class for tab
     * @property {?String} title - Title text for tab
     * @property {?String} super- Super item text for tab
     * @property {Boolean} active - Is this tab active
     */

    /**
     * List of tab items to show
     * @type {Array<TabItem>} TabItems
     */
    this.tabItems = [];

    this.onItemSelected = null;
  }

  $onInit() {
    // Make sure at least one item is active
    if (this.tabItems.find(i => i.active) == null) {
      this.tabItems[0].active = true;
    }
    const div_elem = this.$element.find('nav');

    // Need the dom to render first so that ng-repeat contents are set and tab items exist
    this.$timeout(() => {
      this._tabBar = window.mdc.MDCTabBar.attachTo(div_elem[0]);

      // MDCTabBar:activated fired when a new tab activates
      this._tabBar.listen('MDCTabBar:activated', (...args) => {
        this.$timeout(() => this.onItemSelected({index: args[0].detail.index}));
      });
    });
  }
}

const config = {
  templateUrl: tpl,
  controller: MDCTabBarComponent,
  bindings: {
    tabItems: '<',
    onItemSelected: '&?'
  },
};

const mod = angular.module('common.materialComponents.tabBar', [])

  .component('mdcTabBar', config);

export default mod.name;



// WEBPACK FOOTER //
// ./src/common/material-components/tabs/tab-bar.component.js